import { render, staticRenderFns } from "./PrivatePolicy.vue?vue&type=template&id=8147fedc&scoped=true"
import script from "./PrivatePolicy.vue?vue&type=script&lang=js"
export * from "./PrivatePolicy.vue?vue&type=script&lang=js"
import style0 from "./PrivatePolicy.vue?vue&type=style&index=0&id=8147fedc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8147fedc",
  null
  
)

export default component.exports